import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 10px 10px -10px rgba(0, 0, 0, 0.3)',
    width: 'calc(100% - 2rem)',
    padding: '0.5rem 1rem',
    color: theme.palette.textLight,
    fontSize: theme.size.sm,
    overflow: 'hidden',

    '& .icon': {
      marginRight: '1rem',
      minWidth: '1rem',
      minHeight: '1rem'
    },

    '& .bold': {}
  }
}))

export default useStyles
